module.exports = __webpack_public_path__ + "public/img/16.6b92e3ca.png";